var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./TableHeader.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler?id=data-v-19bd7ccc!../../../vue-loader/lib/selector?type=template&index=0!./TableHeader.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue2-datatable-component/src/Table/TableHeader.vue
// module id = 1218
// module chunks = 2